import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = ['¿Cómo recibo STRETCHING 360 después de comprar?', '¿Sirve para profes con poca experiencia o solo para los avanzados?', '¿Es editable? ¿Puedo modificarlo?', '¿Los 5 bonos y Cuerpo Seguro Pro están incluidos?', '¿Sirve si doy clases individuales o solo para grupos?', '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?', '¿Qué diferencia tiene con otros materiales de Stretching?', '¿Qué incluye Cuerpo Seguro Pro™ sin costo extra?', '¿Tiene garantía real?'];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <Section className="bg-brand-dark" data-id="element-140" data-mp="oqgvcvj54ruw">
      <div className="max-w-3xl mx-auto" data-id="element-141" data-mp="jpswxosl18qn">
        <h2 className="text-2xl md:text-4xl font-display font-black text-white mb-6 md:mb-10 text-center" data-id="element-142" data-mp="jp1b35osepdk">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-3" data-id="element-143" data-mp="1pmtbo43obxu1">
          {faqs.map((question, i) => <div key={i} className="bg-brand-light border border-white/5 rounded-lg overflow-hidden" data-id="element-144" data-mp="1pkqnzqpzugsh" data-mpi={i}>
              <button onClick={() => toggleFAQ(i)} className="w-full text-left p-4 md:p-5 flex items-center justify-between focus:outline-none" data-id="element-145" data-mp="1arn95r3seh5g">
                <span className="font-medium text-white text-sm md:text-base pr-6" data-id="element-146" data-mp="11wyzlor6idau">
                  {question}
                </span>
                <ChevronDown className={`w-4 h-4 text-brand-accent transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-147" data-mp="16pa0attqu34g" />
              </button>

              <AnimatePresence data-id="element-148" data-mp="wz77atmmgp64">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-149" data-mp="iyczac3hkq7z">
                    <div className="px-4 pb-4 md:px-5 md:pb-5 text-gray-400 text-sm" data-id="element-150" data-mp="2kveumybf66lx">
                      <p data-id="element-151" data-mp="2fwkde0t3oq3x">
                        Esta es una respuesta de ejemplo para la pregunta. El
                        material está diseñado para resolver todas tus dudas y
                        darte herramientas prácticas e inmediatas para tus
                        clases de stretching.
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}